// @ts-nocheck
import BodyText from 'atoms/bodyText/bodyText';
import Modal from 'atoms/modal/modal';
import Sheet from 'atoms/sheet/sheet';
import SheetBody from 'atoms/sheet/sheetBody/sheetBody';
import _ from 'lodash';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalActions from '../common/modalActions';
import ModalHeader from '../common/modalHeader';
import * as sagaActions from '../sagaActions';
import Loader from 'atoms/loader';
import * as selectors from '../selectors';
import { Checkbox } from 'antd';
import Label from 'atoms/label/label';
import { isLoadingEnabled } from 'models/loaders/selectors';
import { getData } from 'models/dynamicGrid/sagas';
import { REQUESTS } from 'utils/services/thetaretail/requests';

interface TProps {
	hideModal: React.MouseEventHandler<HTMLDivElement | HTMLButtonElement>;
	selectedTab: string;
}

const TheataRackingIntegration = (props: TProps) => {
	const { hideModal, selectedTab } = props;
	const [erpStatus, updateErpStatus] = useState(false);
	const dispatch = useDispatch();
	const isErpEnabled = useSelector(state => dynamicGridSelectors.getERPStatus(state, selectedTab));
	const [items, setItems] = useState({})
	const selectedOrders = useSelector(state => dynamicGridSelectors.getTableSelection(state, Number(selectedTab)));
	const orders = useSelector(state => dynamicGridSelectors.getGridData(state, Number(selectedTab)));
	const orderTotalCount = useSelector(state => dynamicGridSelectors.getTotalCount(state, Number(selectedTab)));
	useEffect(() => {
		updateErpStatus(isErpEnabled);
	}, [isErpEnabled]);

	useEffect(() => {
		if (!selectedOrders?.selectedRowKeys?.length) return;

		async function fetchData() {
			try {
				const results = await Promise.all(
					selectedOrders.selectedRowKeys.map(async (res) => {
						const { response } = await getData(
							{
								dataProviderOptions: {
									type: "POST",
									...REQUESTS.POST.GET_GRID_DETAILS_V2,
									pathParams: { tableId: 3 },
									version: 2,
									body: {
										fieldGroups: { OrderID: res }
									}
								}
							},
							{},
							true
						);
						return response?.data ? [[res], response?.data] : [[res], []];
					})
				);

				// Flatten results if responses return arrays, otherwise store as-is
				setItems(Object.fromEntries(results));
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		}

		fetchData();

		return () => {
			setItems({}); // Cleanup only when dependencies change
		};
	}, [selectedOrders.selectedRowKeys]);

	const selectedOrderDetails = orders.filter(item => selectedOrders.selectedRowKeys.find(o => item.id === o))

	const data = useMemo(() => ({
		order: selectedOrderDetails
			.filter(order =>
				items.hasOwnProperty(order.OrderID) && items[order.OrderID].length
			)
			.map(order => {
				const inputDetails = items[order.OrderID].filter(i => i?.ItemOrderQty > 0); // Remove items with 0 quantity

				if (inputDetails.length === 0) return null; // Skip orders with no valid items

				return {
					ERPWarehouseID: inputDetails[0]?.ERPWarehouseID,
					ERPStoreID: order?.ERPStoreID,
					OrderBatchID: order?.OrderBatchID?.toString(),
					OrderId: order?.OrderID?.toString(),
					InputDetails: inputDetails.map(i => ({
						ERPShippingMethodId: i?.ERPShipMethodID,
						SKU: i?.SKU,
						ERPItemID: i?.ERPItemId,
						Quantity: i?.ItemOrderQty
					}))
				};
			})
			.filter(order => order !== null) // Remove null values (orders with no valid items)
	}), [items, selectedOrderDetails]);


	const handleRackingIntegration = async (type: string) => {
		// const data = {
		// 	"order": {
		// 		"ERPWarehouseID": "001",
		// 		"ERPStoreID": "029973",
		// 		"OrderBatchID": "12345",
		// 		"OrderId": null,
		// 		"InputDetails": [
		// 			{
		// 				"ERPShippingMethodId": "PALLET GMA",
		// 				"SKU": "5021800",
		// 				"ERPItemID": "1.40QCYRVPWGEC",
		// 				"Quantity": 11
		// 			},
		// 			{
		// 				"ERPShippingMethodId": "PALLET GMA",
		// 				"SKU": "36990",
		// 				"ERPItemID": "PA5DCP",
		// 				"Quantity": 5
		// 			},
		// 			{
		// 				"ERPShippingMethodId": "PALLET GMA",
		// 				"SKU": "115896",
		// 				"ERPItemID": "OG6CM",
		// 				"Quantity": 6
		// 			},
		// 			{
		// 				"ERPShippingMethodId": "PALLET GMA",
		// 				"SKU": "506299",
		// 				"ERPItemID": "PHA5LP",
		// 				"Quantity": 8
		// 			},
		// 			{
		// 				"ERPShippingMethodId": "PALLET GMA",
		// 				"SKU": "131998",
		// 				"ERPItemID": "PHAL2SP",
		// 				"Quantity": 15
		// 			},
		// 			{
		// 				"ERPShippingMethodId": "PALLET GMA",
		// 				"SKU": "5021792",
		// 				"ERPItemID": "1.40QEPGPPWGEC",
		// 				"Quantity": 11
		// 			},
		// 			{
		// 				"ERPShippingMethodId": "PALLET GMA",
		// 				"SKU": "96951",
		// 				"ERPItemID": "BH04",
		// 				"Quantity": 15
		// 			},
		// 			{
		// 				"ERPShippingMethodId": "Palletized - Non Deck",
		// 				"SKU": "471482",
		// 				"ERPItemID": "PCH10",
		// 				"Quantity": 10
		// 			},
		// 			{
		// 				"ERPShippingMethodId": "Bin Box 42\" Lowes Pack 70",
		// 				"SKU": "648901",
		// 				"ERPItemID": "MC1B",
		// 				"Quantity": 15
		// 			},
		// 			{
		// 				"ERPShippingMethodId": "Palletized - Non Deck",
		// 				"SKU": "1287356",
		// 				"ERPItemID": "FL11DUP",
		// 				"Quantity": 15
		// 			}
		// 		]
		// 	}
		// }
		dispatch(sagaActions.rackingIntegrationItems({ selectedTab, data }))
	};

	const isLoadingErp = useSelector(state => isLoadingEnabled(state, 'isLoadingErp'));

	const isLoading = useSelector(state => selectors.getLoadingStatus(state));

	return (
		<Modal hideModal={hideModal}>
			<Sheet isInset>
				<SheetBody>
					<Stack isVertical gutter="small" className="common-modal-content">
						<StackItem className='p-0'>
							<ModalHeader title={'Racking Integration'} />
						</StackItem>
						<StackItem isStretch isGrow className='common-modal-body'>
							{isLoading || isLoadingErp || !Object.keys(items).length ? (
								<Stack isVertical>
									<StackItem isGrow isStretch align="center">
										<Loader />
									</StackItem>
								</Stack>
							) : (
								<Stack isVertical gutter="medium">
									<StackItem>
										<BodyText>
											Are you sure you want to update the racking for the
											{selectedOrders?.isSelectAll
												? orderTotalCount
												: data.order.length}{' '}
											selected orders?
										</BodyText>
									</StackItem>
									{
										Object.keys(items)
											.filter(orderId => items[orderId].some(item => item.ItemOrderQty === 0))
											.length > 0 ? (
											<StackItem>
												<BodyText style={{ color: "red" }}>
													{Object.keys(items)
														.filter(orderId => items[orderId].some(item => item.ItemOrderQty === 0))
														.map(orderId => (
															<div key={orderId}>
																<strong>Order {orderId}</strong> has the following items with **zero quantity**:
																<ul>
																	{items[orderId]
																		.filter(item => item.ItemOrderQty === 0)
																		.map(item => (
																			<li key={item.SKU}>
																				Item: {item.Item} (SKU: {item.SKU}) (Store: {item.Store}) 
																			</li>
																		))}
																</ul>
															</div>
														))}
													<p>Do you want to proceed with the remaining orders and items?</p>
												</BodyText>
											</StackItem>
										) : null
									}

									{isErpEnabled && (
										<StackItem>
											<Stack gutter="small">
												<StackItem>
													<Checkbox
														onChange={e => updateErpStatus(e.target.checked)}
														checked={erpStatus}
													></Checkbox>
												</StackItem>
												<StackItem position="center">
													<Label>ERP Enabled</Label>
												</StackItem>
											</Stack>
										</StackItem>
									)}
								</Stack>
							)}
						</StackItem>
						<StackItem isStretch className='p-0'>
							<ModalActions
								secondaryButtonName={'Cancel'}
								primaryButtonName={'Add Racking'}
								primaryButtonClick={handleRackingIntegration}
								secondaryButtonClick={hideModal}
								getPrimaryDisabledStatus={() => !Object.keys(items).length || !data.order.length}
								isLoading={isLoading}
							/>
						</StackItem>
					</Stack>
				</SheetBody>
			</Sheet>
		</Modal>
	);
};

export default TheataRackingIntegration;
